export class ToggleCartDrawerAction {
  static readonly type = '[UI] Toggle Cart Drawer';
  constructor(public open?: boolean) {}
}

export class SetCartLoadingAction {
  static readonly type = '[UI] Set Cart Loading';
  constructor(public isLoading: boolean) {}
}
